import React, { useState } from 'react';

function MobileEventCalender() {
  return <div>MobileEventCalender</div>;
}

export default MobileEventCalender;
